import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Mutual Funds initial values
export const mutualFundsInitialValues = {
  providerName: "",
  folioNumber: "",
  currentEstimateValue: "",
  units: "",
  fundType: "",
}

// Mutual Funds validation schema
export const mutualFundsValidationSchema = Yup.object().shape({
  name: Yup.string().required("Fund Name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Total Invested Amount is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"),
  providerName: Yup.string().required("Platform/Provider is required"),
  folioNumber: Yup.string()
    .required("Folio Number is required")
    .matches(
      /^\S(?:.*\S)?$/,
      "Space at the beginning or end is not allowed"
    ),
  // Allow the punctuation fund names use, e.g. "Equity – Large Cap", "S&P 500 Index" (ML-35).
  fundType: Yup.string()
  .matches(/^[A-Za-z0-9\s\-–&.,()/]+$/, "Fund type can contain letters, numbers, spaces and - – & . , ( ) /"),
  // .required("Fund type is required"),
  currentEstimateValue: Yup.number()
    .typeError("Must be a positive number")
    .required("Estimated Current Value is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  units: Yup.number()
    .typeError("Must be a valid number")
    .required("Units held is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
})

/**
 * Mutual Funds Form - Field-only component for AddAssets.js
 * This renders only the mutual-funds-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const MutualFundsForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="mutual funds"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default MutualFundsForm
